document.addEventListener('click', (event) => {
    if (!event.target.closest('.c24m-sab-close')) {
        return;
    }

    event.preventDefault();
    document.getElementById('c24m-sab')?.remove();
});
